@use "./Header.module.scss" as *;

.menu {
    position: fixed;
    top: $mobile-nav-height;
    left: 0;
    width: calc(100vw - 16px);
    height: calc(100dvh - #{$mobile-nav-height});
    z-index: 10;
    overflow: hidden;
}

.panel {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: env(safe-area-inset-bottom);
    transition: transform 0.25s ease-out;
}

.offLeft {
    transform: translateX(-100%);
}

.offRight {
    transform: translateX(100%);
}

@media (prefers-reduced-motion: reduce) {
    .panel {
        transition: none;
    }
}

.mainSection {
    padding-block: var(--spacer-24);
}

.topNavSection {
    flex: 1;
    padding-block: var(--spacer-16);
}

.menuList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
}

.menuLink {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding-inline: var(--spacer-24);
    font: var(--font-nav-16-lg);
}

.submenuLink {
    justify-content: space-between;
    cursor: pointer;
}

.caretIcon {
    width: 24px;
    height: 24px;
    fill: currentcolor;
}

.heartIcon {
    width: 16px;
    height: 16px;
    fill: currentcolor;
    margin-right: var(--spacer-8);
}
